import { reactive } from 'vue'
import { createSeedDatabase, type SeedDatabase } from '@/data/seed'

/**
 * VITE_ADMIN_MODE=prototype uses this deterministic in-memory adapter only.
 * Refreshing the page or clearing the preview cache recreates the seed.
 */
export const database = reactive<SeedDatabase>(createSeedDatabase())

export function resetPrototypeDatabase(): SeedDatabase {
  const next = createSeedDatabase()
  for (const key of Object.keys(next) as Array<keyof SeedDatabase>) {
    database[key] = next[key]
  }
  return database
}
